export const environment = {
  name: 'default',
  faxeServiceRootUrl: 'https://hsr.azurewebsites.net',
  faxeChatHub: 'https://hsr.azurewebsites.net/hubs/ChatHub/',
  production: false,
  enableServiceWorker: true
};
